import * as moment from "moment-timezone";

export default (date, timezone) => {
  if (date) {
    date = moment.utc(date);
    if(timezone) {date = date.tz(timezone)}
    if(!timezone) {date = date.local()}
    date = date.format('MMM DD, YYYY')
  }
  return date;
};
